import { observer } from 'mobx-react';
import * as React from 'react';
import { ThemeProvider } from 'telia-front-react/theme-provider';
import 'telia-front-react/polyfill';
import icons from '@teliaee/icons/sprite.svg';
import { useStores } from '@stores/RootStore';

interface Props {
  children?: React.ReactNode;
}

export const getIconPath = (name: string) => icons + name;

const TeliaThemeProvider: React.FC<Props> = (props: Props): React.ReactElement => {
  const { languageStore } = useStores();

  return (
    <ThemeProvider locale={languageStore.currentLocale} theme={'light'} getIconPath={getIconPath}>
      {props.children}
    </ThemeProvider>
  );
};
export default observer(TeliaThemeProvider);
